import React from 'react';
import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';
import { string } from 'prop-types';
import FloatingActionButton from './FloatingActionButton';
import {DesktopWidthL} from '../../Sizes';

const Icon = styled(Glyphicon)`
    
`;

const Style = styled(FloatingActionButton)`
	border-radius: 20px;
	color : ${props => props.color};
	font-size : ${props => props.fontSize};
	padding-left : 16px;
	padding-right : 16px;
	padding-top : 5px;
	padding-bottom : 5px;
	@media (max-width: ${DesktopWidthL}) {
		border-radius: 50%;
		padding-top : 16px;
		padding-bottom : 16px;
	}
`;
const Text = styled.span`
	margin-left 0.5rem;
	@media (max-width: ${DesktopWidthL}) {
		display : none;
	}
`;

const AddFab = ({...props}) => (
	<Style {...props}>
		<Icon  glyph="plus" /> 
		<Text>Create</Text>
	</Style>);

AddFab.propTypes = {
	color: string,
	fontSize: string
};

export default AddFab;

